import styled from "styled-components";

export const MoreGamesBox = styled.div<{shouldDisplay: boolean}>`
    display: ${props => props.shouldDisplay ? "block" : "none"};
    width: 100%;
    padding: 3px 1rem;
`;
